import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { SupplierManufacturer } from "@/app/services/generated/suppliermanufacturerService";
import { supplierManufacturerService } from "@/app/services/extensions/suppliermanufacturerServiceExtended";

export interface IHasSupplierManufacturersCache {
  supplierManufacturers: SupplierManufacturersCache;
}

// Singleton cache store
const supplierManufacturersCacheStore =
  new EntityCacheStore<SupplierManufacturer>(
    EnumCacheEntityType.supplierManufacturer,
    async () => supplierManufacturerService.getAllSupplierManufacturers()
  );

// Ephemeral reader
export default class SupplierManufacturersCache extends EntityWithGuidKeyCache<SupplierManufacturer> {
  constructor() {
    super(supplierManufacturersCacheStore, (x) => x.id);
  }

  get onlySuppliers() {
    return this.allReactive.value.filter(
      (supplierManufacturer) => supplierManufacturer.isSupplier
    );
  }

  get onlyManufacturer() {
    return this.allReactive.value.filter(
      (supplierManufacturer) => supplierManufacturer.isManufacturer
    );
  }

  get allExceptTenant() {
    return this.all.filter((x) => !x.readOnly.isTenant);
  }
}
